import BaseContextMenu from '@components/ContextMenu/BaseContextMenu';
import ThicknessContent from './ThicknessContent';
import { ThicknessMethodType } from 'config/analysisConfig';
import styles from './ThicknessContent.module.scss';

interface ThicknessContextMenuProps {
  value: number;
  method: ThicknessMethodType;
  minValue: number;
  onChangeValue: (val: number) => void;
  onChangeMethod: (method: ThicknessMethodType) => void;
  onReset: ()=>void;
  onClose: () => void;
}

const ThicknessContextMenu = ({
  value,
  method,
  minValue,
  onChangeValue,
  onChangeMethod,
  onReset,
  onClose,
}: ThicknessContextMenuProps) => {
  return (
    <BaseContextMenu onClose={onClose} menuClassName={styles.controller}>
      <ThicknessContent
        minValue={minValue}
        value={value}
        method={method}
        onChangeValue={onChangeValue}
        onChangeMethod={onChangeMethod}
        onReset={onReset}
      />
    </BaseContextMenu>
  );
};

export default ThicknessContextMenu;
